import Utils from '@/components/utils/common.js';
import { computed, onMounted, reactive, ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
/* eslint-disable max-lines-per-function */
export default (props, ctx) => {
    onMounted(() => {
        getFlatResource(authority.value);
    });
    // 初始化数据
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    // console.log('store: ', store);
    // console.log('router: ', router, route);
    const visible = ref(false);
    const left = ref(0);
    const selectedTag = reactive({});
    // const closeAllTag = ref([{ resourceName: '关闭所有', id: 'closeAll', meta: { title: '关闭所有' } }]);
    const closeAllTag = ref([]);
    const allTags = ref([]);
    // const SHOW_MENU_LENGTH = 6;
    const SHOW_MENU_LENGTH = props.maxLength;
    // 扁平化的菜单信息
    const flatResourceSearch = ref([]);

    // 计算属性
    // const user = computed(() => store.getters.user);
    const visitedViews = computed(() => store.getters.visitedViews);
    const authority = computed(() => store.getters.authority);

    // TODO
    // const closeMenu = () => {
    //     visible.value = false;
    // };

    // tagsView相关操作
    const addViewTags = () => {
        const { name } = route;
        const targetMenu = getTargetMenu(flatResourceSearch.value, route.path) || {};
        // console.log(route);
        // console.log(name);
        // console.log(route.fullPath);
        if (route.fullPath === '/' || route.fullPath === props.indexPage) {
            targetMenu.resourceCode = 'reIndex';
            targetMenu.resourceName = '工作台';
        }
        if (name === 'm') {
            router.push(props.indexPage);
        }
        const temp = visitedViews.value.some(item => item.name === name);
        if (name) {
            store.dispatch('addView', {
                ...targetMenu,
                ...route
            });
            if (visitedViews.value.length > SHOW_MENU_LENGTH && !temp) {
                let tempArr = [];
                tempArr = Utils.ArrMove(visitedViews.value, visitedViews.value.length - 1, SHOW_MENU_LENGTH);
                tempArr = Utils.ArrMove(tempArr, 0, tempArr.length - 1);
                store.commit('COVER_VISITED_VIEW', tempArr);
                allTags.value = closeAllTag.value.concat(visitedViews.value.slice(SHOW_MENU_LENGTH));
            }
        } else {
            if (targetMenu.resourceName === '工作台') {
                store.dispatch('addView', {
                    ...targetMenu,
                    ...route
                });
            }
        }
        allTags.value = closeAllTag.value.concat(store.getters.visitedViews.slice(SHOW_MENU_LENGTH));
        return false;
    };
    /**
     * 关闭所有标签
     */
    const closeAllTags = () => {
        // this.$emit('refresh-keep-alive', 'closeAll');
        // lodash.forEach(this.visitedViews, view => {
        //     // 控制页面缓存
        //     this.handlePageCache(view);
        // });
        // this.$store.dispatch('delAllViews');
        // this.$router.push(this.indexPage);
    };
    /**
     * 关闭选择标签
     * @param view 当前选择标签
     */
    const closeSelectedTag = view => {
        if (view.id && view.id === 'closeAll') {
            closeAllTags();
            return false;
        }
        store.dispatch('delView', view).then(({ visitedViews }) => {
            // handlePageCache(view);
            if (isActive(view)) {
                const latestView = visitedViews.pop();
                if (latestView) {
                    router.push(latestView);
                } else {
                    router.push(props.indexPage);
                }
            }
            allTags.value = closeAllTag.value.concat(visitedViews.slice(SHOW_MENU_LENGTH));
        });
    };
    /**
     * 所有标签展开，当前行点击事件
     * @param {item} 当前行数据
     * @param {index} 当前索引
     * @returns void
     */
    const handleClickDropdownItem = (item, index) => {
        // 如果当前行未关闭所有， 执行关闭所有
        // 其他，则执行路由跳转，更新allTags，visited数据数据
        if (item.id && item.id === 'closeAll') {
            closeAllTags();
        } else {
            let tempArr = [];
            tempArr = Utils.ArrMove(visitedViews.value, index + SHOW_MENU_LENGTH - 1, SHOW_MENU_LENGTH);
            tempArr = Utils.ArrMove(tempArr, 0, tempArr.length - 1);
            store.commit('COVER_VISITED_VIEW', tempArr);
            allTags.value = closeAllTag.value.concat(visitedViews.value.slice(SHOW_MENU_LENGTH));
            router.push({ path: item.path, query: item.query, fullPath: item.fullPath });
        }
    };
    /**
     * 鼠标右键事件
     * @param {*}
     * @returns
     */
    const openMenu = (tag, e) => {
        // const menuMinWidth = 105;
        // const offsetWidth = this.$el.offsetWidth; // container width
        // const maxLeft = offsetWidth - menuMinWidth; // left boundary
        // const left = e.clientX; // 15: margin right
        // if (left > maxLeft) {
        //     this.left = maxLeft;
        // } else {
        //     this.left = left;
        // }
        // this.visible = true;
        // this.selectedTag = tag;
    };
    /**
     * 根据路劲找到菜单
     * @param flatResourceSearch 扁平化的菜单信息
     * @param route 当前路由
     * @returns 匹配的菜单信息
     */
    function getTargetMenu(flatResourceSearch, currentPath) {
        return flatResourceSearch.find(item => item.frontUrl === currentPath);
    }
    /**
     * 生成扁平化菜单
     * @param menu 有权限得菜单
     * @returns [] 扁平菜单数据
     */
    function getFlatResource(resource, deep = 0) {
        for (let i = 0; i < resource.length; i++) {
            const ignoreType = 3;
            if (resource[i].resourceType !== ignoreType) {
                flatResourceSearch.value.push(resource[i]);
            }

            if (resource[i].subResources) {
                if (resource[i].subResources.length >= 0) {
                    const nextDeep = deep + 1;
                    getFlatResource(resource[i].subResources, nextDeep);
                }
            }
        }
        setTimeout(() => {
            if (!visitedViews.value[0]) {
                addViewTags();
            }
        }, 100);
    }
    /**
     * 判断当前路由是否激活状态
     */
    const isActive = view => {
        return view.fullPath.split('?')[0] === route.fullPath.split('?')[0];
    };
    /**
     * 控制页面缓存
     * @param {view} 当前菜单
     */
    // function handlePageCache (view) {
    //     const compName = lodash.get(view, 'matched[0].components.default.name');
    //     if (compName) {
    //         this.removeKeepAlivePage(compName);
    //         setTimeout(() => {
    //             this.insertKeepAlivePage(compName);
    //         }, 1000);
    //     }
    // }
    // 数据监听
    watch(
        () => authority,
        val => {
            if (!val.length) closeAllTags();
        }
    );
    watch(
        () => route.path,
        val => {
            if (val) addViewTags();
        }
    );
    watch(
        () => visible,
        val => {
            if (val) {
                document.body.addEventListener('click', this.closeMenu);
            } else {
                document.body.removeEventListener('click', this.closeMenu);
            }
        }
    );
    return {
        visible,
        left,
        selectedTag,
        closeAllTag,
        allTags,
        flatResourceSearch,
        visitedViews,
        isActive,
        handleClickDropdownItem,
        closeSelectedTag,
        openMenu
    };
};
